export default __webpack_public_path__ + "static/media/engine.f9344df9.png";